<template>
  <v-row justify="center">
    <!-- その他課金入力明細 -->
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar color="primary" dark>{{this.title}}</v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="DialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col :cols="6">
                  <ryou-autocomplete :label="'寮生'" :items="userItems"
                                     :itemText="'user_name'" :itemValue="'user_id'" v-model="selectUserObject"
                                     :returnObject="true" :disabled="!addFlg">
                  </ryou-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <ryou-date-format ref="ryou_date_format" v-model="inputDate" :value="inputDate" :label="'課金日'" :type="'date'" :format="'$1/$2/$3'" :rules="inputDateRules">
                  </ryou-date-format>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="4">
                  <RyouCombobox :label="'課金区分'" :items="billingClassItems"
                               :itemText="'billing_name'" :itemValue="'billing_seq_no'" v-model="selectBillingClass" 
                               :value="selectBillingClass" :rules="billingClassNameRules">
                  </RyouCombobox>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <ryou-input v-model="billingName" :value="billingName" :label="'請求名称'"
                              :rules="billingNameRules" :maxlength="32">
                  </ryou-input>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="4">
                  <ryou-input v-model="billingFee" :value="billingFee" :label="'請求代'"
                              :rules="billingFeeRules" :maxlength="5">
                  </ryou-input>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'閉じる'"
                          :handlerClick="handleCancel"
                          :iconCls="'mdi-close'">
          </ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'登録'"
                          :handlerClick="handleOkConfirm"></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-dialog>
  </v-row>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
  import RyouAutocomplete from "@/components/formInput/RyouAutocomplete";
  import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouCombobox from "@/components/formInput/RyouCombobox.vue";

  export default {
    components: {
      RyouBlackBtn,
      RyouConfirm,
      RyouAutocomplete,
      RyouDateFormat,
      RyouInput,
      RyouCombobox,
    },
    props: {
      url: {
        type: Object,
        required: true,
        default: () => { }
      },
      buildingId: {
        type: String,
        required: false,
        default: null,
      },
      buildingGroupId: {
        type: String,
        required: false,
        default: null,
      },
     },

    data: () => ({
      addFlg: true,
      manualFlg: false,
      dialog: false,
      title: "",
      valid: true,
      userItems: [],
      billingClassItems: [],
      selectUserObject: {},
      selectBillingClass: "",
      updBillingClass: "",
      inputDate: "",
      billingSeqNo:"",
      billingName: "",
      billingClassName: "",
      billingFee: "",
      billingDefaultNo: "0", //その他課金マスタに登録されていない区分の場合は請求区分に0を設定
      updBuildId: "",
      billingNameRules: [],
      billingClassNameRules: [],
      inputDateRules:[],
      billingFeeRules:[]
    }),
    mounted() {
      this.billingNameRules.push(this.GlobalRules.required)
      this.billingClassNameRules.push(this.GlobalRules.required)
      this.billingFeeRules.push(this.GlobalRules.required)
      this.billingFeeRules.push(this.GlobalRules.integer)
        this.inputDateRules.push(this.GlobalRules.required);
      //this.fetchBillingClass();
      //this.initData();
    },
    watch: {
      //入力された課金区分名がその他課金マスタに無ければ請求額に0を入れる。
      // 更新時の判定フラグ(manualFlg)を追加。手入力の場合はObject型のデータが取得できないため手入力した課金区分名をbillingClassNameに入れている。
      selectBillingClass(value) {
        if (value === null) {
          return
        }
        if (typeof value === "object") {
          this.billingFee = value.billing_fee
          this.billingClassName = value.billing_name
          this.billingDefaultNo = value.billing_seq_no
        } else {
          this.billingDefaultNo = "0"
          this.billingClassName = value
        }
      }
     },
   
    methods: {
      add() {
        this.addFlg = true
        this.title = "その他課金登録"
        this.open()
      },
      edit(record) {
        this.addFlg = false
        this.manualFlg = true
        this.title = "その他課金更新"
        this.updBuildId = record.building_id
        this.open()

        setTimeout(() => {
          this.billingSeqNo = record.billing_seq_no
          this.selectUserObject = record
          this.inputDate = record.input_date_str
          this.selectBillingClass = record.billing_class_name
          this.billingName = record.billing_name
          this.billingFee = record.billing_fee.toString()
        }, 10);
      },
    
      handleCancel() {
        this.manualFlg = false;
        this.close();
      },

      handleOk() {
        var that = this
        
        //その他課金マスタ以外の区分の場合は請求区分に0を入れる
        if (this.selectBillingClass.billing_seq_no) {
          this.billingDefaultNo = this.selectBillingClass.billing_seq_no.toString()
        } else {
          this.billingDefaultNo = "0"
        }
          if (this.addFlg) {
            //登録
            let params = {
              userId: this.selectUserObject.user_id,
              buildingId: this.selectUserObject.building_id.toString(),
              roomId: this.selectUserObject.room_id,
              inputDate: this.inputDate,
              billingClass: this.billingDefaultNo,
              billingName: this.billingName,
              billingClassName: this.billingClassName,
              billingFee: this.billingFee,
              updUserId: this.$store.getters.getUserId
            }
            this.postRequest(this.url.insert, params, this.$store.getters.getUserToken).then((resp) => {
              if (resp.success) {
                that.$emit("ok");
                this.close()
              }
            });
          } else {
            //更新
            let params = {
              billingSeqNo: this.billingSeqNo.toString(),
              userId: this.selectUserObject.user_id,
              buildingId: this.selectUserObject.building_id.toString(),
              roomId: this.selectUserObject.room_id,
              inputDate: this.inputDate,
              billingClass: this.billingDefaultNo,
              billingClassName: this.billingClassName,
              billingName: this.billingName,
              billingFee: this.billingFee,
              updUserId: this.$store.getters.getUserId
            }
            this.putRequest(this.url.update, params, this.$store.getters.getUserToken).then((resp) => {
              if (resp.success) {
                that.$emit("ok");
                this.close()
              }
            });
          }
      },
      close() {
        
        this.dialog = false;
        // 値初期化
        this.inputDate = ""
      },
      open() {
        this.dialog = true;
        if (this.$refs.DialogForm) {
          this.$refs.DialogForm.reset();
          this.$refs.DialogForm.resetValidation();
        }
        this.initData();
        this.fetchBillingClass();
      },
      //課金区分をDBより取得
      fetchBillingClass() {
        let params = {}
        if (this.manualFlg) {
          params = {
            buildingId: this.updBuildId
          }
        } else {
          params = {
            buildingId: this.buildingId
          }
        }
            this.getRequest(this.url.billingClassGet, params, this.$store.getters.getUserToken).then((data) => {
              if (data.success && data.status == "200") {
                this.billingClassItems = data.result
          }
        });
      },
      //ユーザリストをDBより取得
      initData() {
        let params = {}
        // 更新
        if (this.manualFlg) {
          params = {
            userId: this.$store.getters.getUserId,
            userClass: this.$store.getters.getUserClass,
            withUserId: false,
            buildingId: this.updBuildId
          };
        } else {
          params = {
            userId: this.$store.getters.getUserId,
            userClass: this.$store.getters.getUserClass,
            withUserId: false,
            buildingId: this.buildingId
          };
        }
        this.getRequest(this.url.userGet, params, this.$store.getters.getUserToken).then((data) => {
          if (data.success && data.status == "200") {
            var mapDatas = data.result.map(item => {
              item.user_name = item.building_name + " " + item.room_id + " " + item.user_id + "　" + item.user_name
              return item
            });
            this.userItems = mapDatas;
          }
        });
      },
      //確認ダイアログ
      handleOkConfirm() {
        var valid = this.$refs.DialogForm.validate();
        if (valid) {
          this.$refs.confirm.open("登録", "登録します。宜しいですか？", { color: "info" }).then((confirm) => {
            if (confirm) {
              this.handleOk();
            }
          });
        }
      },

    }

}

</script>

<style scoped>
  .InsertTitle {
    padding: 0px 0px 12px !important;
  }

  .InsertTitle1 {
    padding: 5px 0px 0px 0px;
  }

</style>